"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContext = void 0;
const date_1 = require("./fn/date");
const formatting_1 = require("./fn/formatting");
const list_1 = require("./fn/list");
const logic_1 = require("./fn/logic");
const map_1 = require("./fn/map");
const math_1 = require("./fn/math");
const text_1 = require("./fn/text");
const unsupported_fn_1 = require("./utils/unsupported-fn");
const getContext = (extend) => ({
    ...(typeof extend === "object" ? extend : null),
    fn: {
        list: list_1.list,
        map: map_1.map,
        date: date_1.date,
        formatting: formatting_1.formatting,
        logic: logic_1.logic,
        math: math_1.math,
        text: text_1.text,
        table: {
            lookup: (0, unsupported_fn_1.unsupportedFn)("fn.table.lookup"),
            rangelookup: (0, unsupported_fn_1.unsupportedFn)("fn.table.rangelookup"),
        },
    },
});
exports.getContext = getContext;
//# sourceMappingURL=get-context.js.map